module.exports = __webpack_public_path__ + "img/pms2.d515c37.jpg";